import Layout from 'components/layout/Layout'
import { serverSideTranslations } from 'next-i18next/pages/serverSideTranslations'
import i18nConfig from 'utils/i18nConfig'
import { faqCategoriesSlugs } from 'constants/faq-categories'
import { FAQCategories } from 'features/faq-page/types'
import Move from 'features/move/Move'
import { DEFAULT_NAMESPACES } from 'constants/i18n'
import { useTranslation } from 'next-i18next/pages'
import type { MoveProps } from 'features/move/types'
import type { SeoProps } from 'components/seo/types'
import { cmsLib } from 'lib'
import { getLowerCaseLanguage } from 'utils/language'

const MovePage = (props: MoveProps) => {
  // i18n
  const { t } = useTranslation('move')

  // Constants
  const seo: SeoProps = {
    description: t(($) => $.seo.description),
    title: t(($) => $.seo.title)
  }

  return (
    <Layout {...{ seo }}>
      <Move {...props} />
    </Layout>
  )
}

export const getStaticProps = async ({ locale }) => {
  const language = getLowerCaseLanguage(locale)
  const categories = await cmsLib.getFaqCategories(faqCategoriesSlugs[FAQCategories.MOVE], language)

  return {
    props: {
      categories,
      ...(await serverSideTranslations(locale, [...DEFAULT_NAMESPACES, 'move'], i18nConfig))
    },
    revalidate: 60 // In seconds
  }
}

export default MovePage
